class VideoPopup {
  constructor() {
    this.videos = [];
    this.popup = null;
    this.init();
  }

  init() {
    // Небольшая задержка чтобы все элементы успели загрузиться
    setTimeout(() => {
      this.findVideos();
      console.log('VideoPopup: Найдено видео:', this.videos.length);
      if (this.videos.length > 0) {
        this.createPopup();
        this.addPlayButtons();
        this.attachEventListeners();
        console.log('VideoPopup: Кнопки добавлены');
      } else {
        console.log('VideoPopup: Видео не найдено на странице');
      }
    }, 100);
  }

  findVideos() {
    // Находим все типы видео
    // 1. HTML5 video теги (уже загруженные)
    document.querySelectorAll('video:not([data-video-popup-processed])').forEach(video => {
      // Пропускаем видео с классом no-popup
      if (video.classList.contains('no-popup') || video.closest('.no-popup')) {
        return;
      }
      
      if (!video.closest('.video-popup-button-wrapper')) {
        video.setAttribute('data-video-popup-processed', 'true');
        const container = this.getVideoContainer(video);
        this.videos.push({
          element: container || video,
          type: 'html5',
          src: video.src || video.querySelector('source')?.src,
          videoElement: video
        });
      }
    });

    // 2. iframe с YouTube/Vimeo (уже загруженные)
    document.querySelectorAll('iframe[src*="youtube"], iframe[src*="youtu.be"], iframe[src*="vimeo"]').forEach(iframe => {
      // Пропускаем iframe с классом no-popup или внутри элемента с классом no-popup
      if (iframe.classList.contains('no-popup') || iframe.closest('.no-popup')) {
        return;
      }
      
      if (!iframe.closest('.video-popup-button-wrapper') && !iframe.hasAttribute('data-video-popup-processed')) {
        iframe.setAttribute('data-video-popup-processed', 'true');
        const src = iframe.getAttribute('src');
        let videoId = null;
        let type = null;

        if (src && (src.includes('youtube.com') || src.includes('youtu.be'))) {
          type = 'youtube';
          const match = src.match(/(?:youtube\.com\/embed\/|youtu\.be\/|youtube\.com\/watch\?v=)([^&\s?]+)/);
          if (match) videoId = match[1];
        } else if (src && src.includes('vimeo.com')) {
          type = 'vimeo';
          const match = src.match(/vimeo\.com\/video\/(\d+)/);
          if (match) videoId = match[1];
        }

        if (videoId) {
          const container = this.getVideoContainer(iframe);
          this.videos.push({
            element: container || iframe,
            type: type,
            videoId: videoId,
            src: src
          });
        }
      }
    });

    // 3. deferred-media с видео в template
    document.querySelectorAll('deferred-media:not([data-video-popup-processed])').forEach(deferredMedia => {
      // Пропускаем deferred-media с классом no-popup
      if (deferredMedia.classList.contains('no-popup') || deferredMedia.closest('.no-popup')) {
        return;
      }
      
      if (deferredMedia.closest('.video-popup-button-wrapper')) {
        return;
      }

      deferredMedia.setAttribute('data-video-popup-processed', 'true');
      const template = deferredMedia.querySelector('template');
      
      if (!template) return;

      // Получаем содержимое template
      let content = null;
      if (template.content) {
        content = template.content;
      } else {
        // Fallback для старых браузеров
        content = template;
      }

      // Проверяем iframe внутри template
      const iframe = content.querySelector('iframe');
      if (iframe) {
        const src = iframe.getAttribute('src') || '';
        let videoId = null;
        let type = null;

        if (src.includes('youtube.com') || src.includes('youtu.be')) {
          type = 'youtube';
          const match = src.match(/(?:youtube\.com\/embed\/|youtu\.be\/|youtube\.com\/watch\?v=)([^&\s?]+)/);
          if (match) videoId = match[1];
        } else if (src.includes('vimeo.com')) {
          type = 'vimeo';
          const match = src.match(/vimeo\.com\/video\/(\d+)/);
          if (match) videoId = match[1];
        }

        if (videoId) {
          this.videos.push({
            element: deferredMedia,
            type: type,
            videoId: videoId,
            isTemplate: true
          });
          return;
        }
      }

      // Проверяем video тег внутри template
      const video = content.querySelector('video');
      if (video) {
        this.videos.push({
          element: deferredMedia,
          type: 'html5',
          src: video.getAttribute('src') || video.querySelector('source')?.getAttribute('src'),
          isTemplate: true,
          videoElement: video
        });
      }
    });
  }

  getVideoContainer(element) {
    // Ищем ближайший контейнер с позиционированием или создаем его
    let container = element.parentElement;
    
    while (container && container !== document.body) {
      const style = window.getComputedStyle(container);
      if (style.position !== 'static' || container.classList.contains('media') || container.classList.contains('video-section')) {
        return container;
      }
      container = container.parentElement;
    }

    return null;
  }

  createPopup() {
    // Создаем попап
    const popup = document.createElement('div');
    popup.className = 'video-popup-modal';
    popup.innerHTML = `
      <div class="video-popup-overlay"></div>
      <div class="video-popup-container">
        <button class="video-popup-close" aria-label="Close video">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
        <div class="video-popup-content"></div>
      </div>
    `;
    document.body.appendChild(popup);
    this.popup = popup;
  }

  addPlayButtons() {
    this.videos.forEach((video, index) => {
      const element = video.element;
      
      // Если элемент - это video тег, добавляем кнопку в родительский контейнер
      let targetContainer = element;
      
      // Если это video элемент, нужно найти подходящий контейнер
      if (element.tagName === 'VIDEO') {
        // Ищем родительский контейнер с классом или id
        let parent = element.parentElement;
        while (parent && parent !== document.body) {
          // Если родитель имеет класс или это div/section, используем его
          if (parent.classList.length > 0 || parent.tagName === 'DIV' || parent.tagName === 'SECTION') {
            targetContainer = parent;
            break;
          }
          parent = parent.parentElement;
        }
        
        // Если не нашли подходящий контейнер, создаем обертку
        if (targetContainer === element || !targetContainer) {
          const wrapper = document.createElement('div');
          wrapper.className = 'video-popup-wrapper';
          wrapper.style.position = 'relative';
          wrapper.style.display = 'inline-block';
          element.parentNode.insertBefore(wrapper, element);
          wrapper.appendChild(element);
          targetContainer = wrapper;
        }
      }

      // Проверяем, не добавлена ли уже кнопка
      if (targetContainer.querySelector('.video-popup-button') || targetContainer.closest('.video-popup-button-wrapper')) {
        console.log('VideoPopup: Кнопка уже существует для видео', index);
        return;
      }

      console.log('VideoPopup: Добавляю кнопку для видео', index, element, 'в контейнер', targetContainer);

      // Убеждаемся, что контейнер имеет position: relative
      const computedStyle = window.getComputedStyle(targetContainer);
      const isPositioned = computedStyle.position !== 'static';
      
      if (!isPositioned) {
        targetContainer.style.position = 'relative';
      }

      // Для deferred-media добавляем кнопку в poster, если он есть
      const poster = element.querySelector('.deferred-media__poster, [id^="Deferred-Poster-"]');
      if (poster) {
        targetContainer = poster;
        // Убеждаемся что poster тоже имеет position: relative
        const posterStyle = window.getComputedStyle(poster);
        if (posterStyle.position === 'static') {
          poster.style.position = 'relative';
        }
        // Убеждаемся что overflow не скрывает кнопку
        if (posterStyle.overflow === 'hidden') {
          poster.style.overflow = 'visible';
        }
      }
      
      // Также проверяем родительский deferred-media на overflow
      const deferredMedia = element.closest('deferred-media');
      if (deferredMedia) {
        const dmStyle = window.getComputedStyle(deferredMedia);
        if (dmStyle.overflow === 'hidden') {
          deferredMedia.style.overflow = 'visible';
        }
      }

      // Добавляем класс и data-атрибут для обработки клика на контейнер
      targetContainer.classList.add('video-popup-container-element');
      targetContainer.setAttribute('data-video-index', index);
      targetContainer.style.cursor = 'pointer';
      
      // Если element не совпадает с targetContainer, также добавляем класс на element
      if (element !== targetContainer) {
        element.classList.add('video-popup-video-element');
      }

      // Убираем controls с видео на странице и предотвращаем автозапуск
      if (element.tagName === 'VIDEO') {
        element.removeAttribute('controls');
        element.removeAttribute('autoplay');
        element.setAttribute('data-no-controls', 'true');
        // Блокируем воспроизведение на странице
        element.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const idx = parseInt(targetContainer.getAttribute('data-video-index'));
          if (!isNaN(idx) && this.videos[idx]) {
            this.openPopup(this.videos[idx]);
          }
          return false;
        }, true);
      }

      // Создаем кнопку
      const button = document.createElement('button');
      button.className = 'video-popup-button';
      button.setAttribute('data-video-index', index);
      button.setAttribute('aria-label', 'Play video');
      button.innerHTML = `
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M40 0C17.9427 0 0 17.9444 0 40C0 62.0556 17.9427 80 40 80C62.0573 80 80 62.0556 80 40C80 17.9444 62.0573 0 40 0ZM55.9017 41.4014L32.5684 56.4014C32.295 56.5788 31.9792 56.6667 31.6667 56.6667C31.3933 56.6667 31.1166 56.5983 30.8692 56.4633C30.332 56.1703 30 55.6103 30 55V25C30 24.3897 30.332 23.8297 30.8692 23.5367C31.3966 23.247 32.0573 23.2648 32.5684 23.5986L55.9017 38.5986C56.377 38.9045 56.6667 39.4336 56.6667 40C56.6667 40.5664 56.377 41.0953 55.9017 41.4014Z" fill="white" fill-opacity="0.8"/>
        </svg>
      `;

      // Добавляем кнопку в целевой контейнер (НЕ в video элемент)
      targetContainer.appendChild(button);
      
      // Убеждаемся что кнопка видна
      console.log('VideoPopup: Кнопка добавлена в', targetContainer, 'Видимость:', window.getComputedStyle(button).visibility, 'z-index:', window.getComputedStyle(button).zIndex);
    });
  }

  attachEventListeners() {
    // Обработчики для кнопок воспроизведения
    document.querySelectorAll('.video-popup-button').forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const index = parseInt(button.getAttribute('data-video-index'));
        this.openPopup(this.videos[index]);
      });
    });

    // Обработчики для клика по контейнеру видео
    document.querySelectorAll('.video-popup-container-element').forEach(container => {
      container.addEventListener('click', (e) => {
        // Игнорируем клик если он был на кнопке (уже обработан выше)
        if (e.target.closest('.video-popup-button')) {
          return;
        }
        
        // Игнорируем клик на iframe, но обрабатываем клик на video
        if (e.target.tagName === 'IFRAME') {
          return;
        }
        
        // Для video элементов также открываем модалку
        if (e.target.tagName === 'VIDEO') {
          e.preventDefault();
          e.stopPropagation();
        }

        const index = parseInt(container.getAttribute('data-video-index'));
        if (!isNaN(index) && this.videos[index]) {
          this.openPopup(this.videos[index]);
        }
      });
    });

    // Закрытие попапа
    const closeBtn = this.popup.querySelector('.video-popup-close');
    const overlay = this.popup.querySelector('.video-popup-overlay');
    
    [closeBtn, overlay].forEach(element => {
      element.addEventListener('click', () => {
        this.closePopup();
      });
    });

    // Закрытие по ESC
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.popup.classList.contains('active')) {
        this.closePopup();
      }
    });
  }

  openPopup(video) {
    const content = this.popup.querySelector('.video-popup-content');
    content.innerHTML = '';

    let videoHTML = '';

    if (video.type === 'youtube') {
      videoHTML = `
        <iframe
          src="https://www.youtube.com/embed/${video.videoId}?autoplay=1&enablejsapi=1"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      `;
    } else if (video.type === 'vimeo') {
      videoHTML = `
        <iframe
          src="https://player.vimeo.com/video/${video.videoId}?autoplay=1"
          frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowfullscreen
        ></iframe>
      `;
    } else if (video.type === 'html5') {
      let videoElement = null;
      
      if (video.isTemplate && video.videoElement) {
        // Клонируем video элемент из template
        videoElement = video.videoElement.cloneNode(true);
      } else if (video.videoElement) {
        videoElement = video.videoElement.cloneNode(true);
      } else {
        // Ищем video элемент в контейнере
        videoElement = video.element.querySelector('video');
        if (videoElement) {
          videoElement = videoElement.cloneNode(true);
        } else if (video.element.tagName === 'VIDEO') {
          videoElement = video.element.cloneNode(true);
        }
      }

      if (videoElement) {
        // В модалке добавляем controls и автозапуск
        videoElement.setAttribute('controls', 'true');
        videoElement.setAttribute('autoplay', 'true');
        // Убираем атрибут который блокирует controls на странице
        videoElement.removeAttribute('data-no-controls');
        if (!videoElement.src && video.src) {
          videoElement.src = video.src;
        }
        content.appendChild(videoElement);
        this.popup.classList.add('active');
        document.body.style.overflow = 'hidden';
        return;
      }
    }

    content.innerHTML = videoHTML;
    this.popup.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  closePopup() {
    this.popup.classList.remove('active');
    document.body.style.overflow = '';
    
    // Останавливаем видео при закрытии
    const iframe = this.popup.querySelector('iframe');
    if (iframe) {
      const src = iframe.src;
      iframe.src = '';
      // Небольшая задержка перед удалением, чтобы плавно закрылось
      setTimeout(() => {
        iframe.src = src.replace('autoplay=1', 'autoplay=0');
      }, 300);
    }

    const video = this.popup.querySelector('video');
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  }
}

// Инициализация после загрузки DOM
function initVideoPopup() {
  // Удаляем старые экземпляры если есть
  if (window.videoPopupInstance) {
    return;
  }
  window.videoPopupInstance = new VideoPopup();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(initVideoPopup, 200);
  });
} else {
  setTimeout(initVideoPopup, 200);
}

// Переинициализация для динамически добавленного контента (Shopify sections)
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    setTimeout(() => {
      if (window.videoPopupInstance) {
        window.videoPopupInstance.findVideos();
        window.videoPopupInstance.addPlayButtons();
        window.videoPopupInstance.attachEventListeners();
      } else {
        initVideoPopup();
      }
    }, 300);
  });
}

// Также переинициализация при изменении страницы через AJAX
document.addEventListener('shopify:section:reorder', () => {
  setTimeout(() => {
    if (window.videoPopupInstance) {
      window.videoPopupInstance.findVideos();
      window.videoPopupInstance.addPlayButtons();
      window.videoPopupInstance.attachEventListeners();
    }
  }, 300);
});

